import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import storage from "redux-persist/lib/storage";
import { SURVEY_ANSWERS_SLICE_NAME } from "@utils/redux/slices/surveyAnswers";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [SURVEY_ANSWERS_SLICE_NAME],
  stateReconciler: hardSet,
};

const persistMiddleware = getDefaultMiddleware({
  serializableCheck: {
    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
  },
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: persistMiddleware,
});

export const persistor = persistStore(store);

/**
 * Attaches a change listener to the store.
 * @param {function} select return state derived from store
 * @param {function} onChange change listener callback
 */
export function observeStore(select, onChange) {
  let currentState = select(store.getState());

  const handleChange = () => {
    const nextState = select(store.getState());
    if (!isEqual(nextState, currentState)) {
      currentState = nextState;
      onChange(currentState);
    }
  };

  return store.subscribe(handleChange);
}

export default store;
